import { empty, h, pill, replace } from "../dom";
import { when } from "../format";
import { eventLabel, eventTone, historyLink } from "../history";
import type { HistoryEntry } from "../types";
import { plain } from "../words";

// A History section (order_history): what happened, newest first, who did it, the reason where one was given, and
// the email, exception or document to open. The latest SHOWN entries, then "Show all".

const SHOWN = 15;

function entry(e: HistoryEntry): HTMLElement {
  const link = historyLink(e);
  const tone = eventTone(e.event);
  return h("li", { class: "card history" },
    h("div", { class: "row-act" },
      h("span", { class: "num caption" }, `${when(e.at)} · ${e.by}`),
      pill(eventLabel(e.event), tone)),
    h("span", null, plain(e.what)),
    e.note ? h("span", { class: "caption" }, `“${plain(e.note)}”`) : null,
    link ? h("a", { href: link.href }, link.text) : null);
}

export function historySection(entries: HistoryEntry[], emptyText: string): HTMLElement {
  const list = h("ul", { class: "cards" }, entries.slice(0, SHOWN).map(entry));
  const more = entries.length > SHOWN ? h("button", { type: "button", class: "button button-small" }, `Show all ${entries.length}`) : null;
  more?.addEventListener("click", () => {
    replace(list, entries.map(entry));
    more.remove();
  });
  return h("section", { class: "stack", "aria-labelledby": "history" },
    h("h2", { id: "history", class: "heading" }, "History"),
    entries.length ? [list, more] : empty("Nothing recorded yet", emptyText));
}
